import React, { useEffect, useRef, useState } from 'react';

export const IMG = {
  robotDock: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png',
  features: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/unyfq400_8.%20LumineX%20300.png',
  heroBg: 'https://images.unsplash.com/photo-1762859731349-c9ff2808b672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHx3aGl0ZSUyMHJvYm90JTIwdmFjdXVtJTIwY2xlYW5lciUyMG1vZGVybnxlbnwwfHx8fDE3ODU0OTM4ODR8MA&ixlib=rb-4.1.0&q=85&w=1920',
  mopFloor: 'https://images.unsplash.com/photo-1600322305530-45714a0bc945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHx3aGl0ZSUyMHJvYm90JTIwdmFjdXVtJTIwY2xlYW5lciUyMG1vZGVybnxlbnwwfHx8fDE3ODU0OTM4ODR8MA&ixlib=rb-4.1.0&q=85&w=1400',
  pool: 'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/3y07x1gj_aee2706b-9652-4a2b-8c52-5c06900c5667.png',
  lawn: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/h221a4vl_4885c0df-e93f-4fc7-b5f9-c51e42ee3ac0-md.jpeg',
  warehouse: 'https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBpbnRlcmlvciUyMGNsZWFufGVufDB8fHx8MTc4NTQ5MzkwM3ww&ixlib=rb-4.1.0&q=85&w=1920',
  windowGlass: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/6j2kav5l_Window%20robo.jpeg',
  escargot: 'https://customer-assets.emergentagent.com/job_80fffe0f-7ad4-44ce-aa36-08a4bccc4edb/artifacts/78savfvp_jan.png',
  airPurifier: 'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/yy8o4d6u_IMG_1002.jpg',
};

export const PRICE = '₹29,990';

export const useInView = (threshold = 0.25) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
};

export const Reveal = ({ children, className = '', delay = 0, as: Tag = 'div', ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <Tag ref={ref} className={`hv2-reveal ${inView ? 'hv2-in' : ''} ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};

export const Overline = ({ children, dark }) => (
  <p className={`font-manrope text-xs md:text-sm uppercase tracking-[0.25em] font-bold mb-6 ${dark ? 'text-[#00AEEF]' : 'text-[#0057B8]'}`}>{children}</p>
);
